// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2F5vW","visuallyhidden":"Fx3Ec","hide-text":"_2JOOm","center":"Jjo5R","noprint":"sczMY","external-articles":"_2Fxqb","source":"BVFnu"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-external-articles/styles/default.scss
 ** module id = 997
 ** module chunks = 2
 **/